/* eslint-disable no-mixed-operators */
import React from "react"
import {FormikProps} from "formik/dist/types"
import {
    getInternalSearchFieldsConfigurationsBy, isApplicableFieldFromConfigurations, isDisabledFieldFromConfigurations,
    isProductionSearchField,
    isUpdateResultsSearchAvailable,
} from "../../../helpers/configurationHelper"
import DynamicSearchField from "./DynamicSearchField"
import {ConfigurationsType} from "../../../types/configurations"
import {ProductImageStacType} from "../../../types/product"
import {ShapeType} from "../../../types/shape"
import {AppParametersType} from "../../../types/app"

interface PropsType {
    configurations: ConfigurationsType;
    scopeConfigurationFields: string;
    selectedProducts: ProductImageStacType[];
    selectedArea?: ShapeType;
    formProps: FormikProps<any>;
    labelClassName?: string;
    inputClassName?: string;
    appParameters: AppParametersType;
    hasOnlyProductId?: boolean;
}

const DynamicSearchFieldsList = (props: PropsType) => {
  const {
    configurations,
    scopeConfigurationFields,
    selectedProducts,
    selectedArea,
    formProps,
    labelClassName,
    inputClassName,
    appParameters,
    hasOnlyProductId,
  } = props

  const {values} = formProps

  const fieldsConfigurations = getInternalSearchFieldsConfigurationsBy(
    configurations,
    appParameters,
    scopeConfigurationFields,
    values
  )

  let component
  if (fieldsConfigurations && fieldsConfigurations.length > 0) {
    component = [
      ...(hasOnlyProductId
        ? fieldsConfigurations.filter((elem) => elem.name === "productId")
        : fieldsConfigurations),
    ].map((fieldConfigurations) => (
      <DynamicSearchField
        key={`dynamic-search-fields-list-element-${fieldConfigurations.name}`}
        hidden={isProductionSearchField(fieldConfigurations)}
        configurations={configurations}
        fieldConfigurations={fieldConfigurations}
        scopeConfigurationFields={scopeConfigurationFields}
        selectedArea={selectedArea}
        formProps={formProps}
        forceDisabled={isDisabledFieldFromConfigurations(configurations,
            appParameters,
            scopeConfigurationFields,
            fieldConfigurations.name,
            values, selectedArea as ShapeType)}
        disabled={
          isProductionSearchField(fieldConfigurations) &&
          isUpdateResultsSearchAvailable(
            configurations,
            appParameters,
            values,
            selectedProducts
          )
        }
        labelClassName={labelClassName}
        inputClassName={inputClassName}
        appParameters={appParameters}
      />
    ))
  }

  return component || <div />
}

export default DynamicSearchFieldsList
